import {
  IonButtons,
  IonContent,
  IonHeader,
  IonMenuButton,
  IonPage,
  IonTitle,
  IonToolbar,
  IonCol,
  IonRow,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonGrid,
} from "@ionic/react";
import { useParams } from "react-router";
import ExploreContainer from "../components/ExploreContainer";
import { Descriptions, Row, Col, notification, Table, Tag, Form } from "antd";
import { Card } from "antd";
import { Switch } from "antd";
import { Input } from "antd";
import moment from "moment";
import { PageHeader } from "antd";

import { DatePicker, Space, Button, Image } from "antd";

import React, { useState } from "react";
import { Link } from "react-router-dom";

const LessorDetails: React.FC = (props: any) => {
  const user = JSON.parse(localStorage.getItem("userobject") || "{}");
  const [PropertyObject, setState] = useState({
    ProfileStatus: "",
    VerifiedStatus: "",
    Usertype: "",
    ID: "",
    Name: "",
    Email: "",
    ContactNumber: "",
    AdditionalContact: "",
    Password: "",
    RejectionReason: "",
  });
  const handleChange = (e: { target: { name: any; value: any } }) => {
    const { name, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    setState((prevState) => ({
      ...prevState,
      userid: user.id,
    }));
  };

  const handleChangecheckbox = (e: any, name: any) => {
    setState((prevState) => ({
      ...prevState,
      [name]: e,
    }));
  };

  const { name } = useParams<{ name: string }>();
  const { Column, ColumnGroup } = Table;

  

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonRow>
            <PageHeader
              className="site-page-header"
              onBack={() => {
                props.history.goBack();
              }}
              title="Lessor Details"
            />
          </IonRow>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">{name}</IonTitle>
          </IonToolbar>
        </IonHeader>
        <Space direction="vertical">
          <IonGrid>
            <IonRow>
              <IonCol size="13" style={{ paddingLeft: "40px" }}>
                <IonCard>
                  <IonCardHeader></IonCardHeader>

                  <IonCardContent>
                    <Form>
                      <IonRow>
                        <IonCol>
                          <Form.Item
                            label="Profile status"
                            name="ProfileStatus"
                            rules={[
                              {
                                required: true,
                                message: "Please input your username!",
                              },
                            ]}
                          >
                            <Input
                              value={PropertyObject.ProfileStatus}
                              onChange={handleChange}
                            />
                          </Form.Item>
                        </IonCol>
                        <IonCol>
                          <Form.Item
                            label="Verified status"
                            name="VerifiedStatus"
                            rules={[
                              {
                                required: true,
                                message: "Please input your password!",
                              },
                            ]}
                          >
                            <Input
                              value={PropertyObject.VerifiedStatus}
                              onChange={handleChange}
                            />
                          </Form.Item>
                        </IonCol>

                        <IonCol>
                          <Form.Item
                            label="user type"
                            name="UserType"
                            rules={[
                              {
                                required: true,
                                message: "Please input your password!",
                              },
                            ]}
                          >
                            <Input
                              value={PropertyObject.Usertype}
                              onChange={handleChange}
                            />
                          </Form.Item>
                        </IonCol>
                      </IonRow>

                      <IonRow>
                        <IonCol>
                          <Form.Item
                            label="ID"
                            name="ID"
                            rules={[
                              {
                                required: true,
                                message: "Please input your username!",
                              },
                            ]}
                          >
                            <Input
                              value={PropertyObject.ID}
                              onChange={handleChange}
                            />
                          </Form.Item>
                        </IonCol>
                        <IonCol>
                          <Form.Item
                            label="Name"
                            name="Name"
                            rules={[
                              {
                                required: true,
                                message: "Please input your password!",
                              },
                            ]}
                          >
                            <Input
                              value={PropertyObject.Name}
                              onChange={handleChange}
                            />
                          </Form.Item>
                        </IonCol>

                        <IonCol>
                          <Form.Item
                            label="Email"
                            name="Email"
                            rules={[
                              {
                                required: true,
                                message: "Please input your password!",
                              },
                            ]}
                          >
                            <Input
                              value={PropertyObject.Email}
                              onChange={handleChange}
                            />
                          </Form.Item>
                        </IonCol>
                      </IonRow>
                      <IonRow>
                        <IonCol>
                          <p>Profile picture</p>
                          <Image
                            width={200}
                            src="https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png"
                          />
                        </IonCol>
                        <IonCol>
                          <Form.Item
                            label="Contact Number"
                            name="ContactNumber"
                            rules={[
                              {
                                required: true,
                                message: "Please input your password!",
                              },
                            ]}
                          >
                            <Input
                              value={PropertyObject.ContactNumber}
                              onChange={handleChange}
                            />
                          </Form.Item>
                        </IonCol>

                        <IonCol>
                          <Form.Item
                            label="Additional Contact Number"
                            name="UserType"
                            rules={[
                              {
                                required: true,
                                message: "Please input your password!",
                              },
                            ]}
                          >
                            <Input
                              value={PropertyObject.AdditionalContact}
                              onChange={handleChange}
                            />
                          </Form.Item>
                        </IonCol>
                      </IonRow>

                      <IonRow>
                        <IonCol>
                          <p>Business picture</p>
                          <Image
                            width={200}
                            src="https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png"
                          />
                        </IonCol>
                        <IonCol>
                          <Form.Item
                            label="Password"
                            name="Password"
                            rules={[
                              {
                                required: true,
                                message: "Please input your password!",
                              },
                            ]}
                          >
                            <Input.Password
                              value={PropertyObject.Password}
                              onChange={handleChange}
                            />
                          </Form.Item>
                        </IonCol>

                        <IonCol>
                          <Form.Item
                            label="Rejection Reason"
                            name="RejectionReason"
                            rules={[
                              {
                                required: true,
                                message: "Please input your password!",
                              },
                            ]}
                          >
                            <Input
                              value={PropertyObject.RejectionReason}
                              onChange={handleChange}
                            />
                          </Form.Item>
                        </IonCol>
                      </IonRow>

                      {/* <Form.Item {...tailLayout}>
                  
                      </Form.Item> */}
                    </Form>
                  </IonCardContent>
                </IonCard>
              </IonCol>
            </IonRow>
          </IonGrid>
        </Space>
      </IonContent>
    </IonPage>
  );
};

export default LessorDetails;
